import { render, staticRenderFns } from "./GenderDashboardItem.vue?vue&type=template&id=1e0d9dbc&scoped=true"
import script from "./GenderDashboardItem.vue?vue&type=script&lang=js"
export * from "./GenderDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./GenderDashboardItem.vue?vue&type=style&index=0&id=1e0d9dbc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0d9dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e0d9dbc')) {
      api.createRecord('1e0d9dbc', component.options)
    } else {
      api.reload('1e0d9dbc', component.options)
    }
    module.hot.accept("./GenderDashboardItem.vue?vue&type=template&id=1e0d9dbc&scoped=true", function () {
      api.rerender('1e0d9dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/GenderDashboardItem.vue"
export default component.exports